import {
  IEnrStatusChipBaseVariant,
  IEnrStatusChipSize,
  IEnrStatusChipVariant,
} from "./EnrStatusChip.types";

export const ENR_STATUS_CHIP_SIZES: Record<
  IEnrStatusChipSize,
  {
    width: number;
    height: number;
    fontSize: string;
    highlightFontSize: string;
  }
> = {
  XS: {
    width: 90,
    height: 20,
    fontSize: "0.65rem",
    highlightFontSize: "0.65rem",
  },
  SM: {
    width: 120,
    height: 24,
    fontSize: "0.75rem",
    highlightFontSize: "0.75rem",
  },
  MD: {
    width: 160,
    height: 28,
    fontSize: "0.85rem",
    highlightFontSize: "0.8rem",
  },
  LG: {
    width: 200,
    height: 32,
    fontSize: "0.95rem",
    highlightFontSize: "0.9rem",
  },
};

export const ENR_STATUS_CHIP_BASE_COLORS: Record<
  IEnrStatusChipBaseVariant,
  {
    base: string;
    border: string;
    text: string;
    soft: string;
    strong: string;
  }
> = {
  WARNING: {
    base: "#FFF8E1",
    border: "#FACC15",
    text: "#5D2F13",
    soft: "#FEF3C7",
    strong: "#F59E0B",
  },
  ERROR: {
    base: "#FEF2F2",
    border: "#F87171",
    text: "#7F1D1D",
    soft: "#FEE2E2",
    strong: "#EF4444",
  },
  SUCCESS: {
    base: "#ECFDF5",
    border: "#34D399",
    text: "#065F46",
    soft: "#D1FAE5",
    strong: "#10B981",
  },
  INFO: {
    base: "#EFF6FF",
    border: "#60A5FA",
    text: "#1E3A8A",
    soft: "#DBEAFE",
    strong: "#3B82F6",
  },
  PRIMARY: {
    base: "#EEF2FF",
    border: "#6366F1",
    text: "#312E81",
    soft: "#E0E7FF",
    strong: "#4F46E5",
  },
  SECONDARY: {
    base: "#FAF5FF",
    border: "#A855F7",
    text: "#581C87",
    soft: "#F3E8FF",
    strong: "#9333EA",
  },
  ACTIVE: {
    base: "#ECFDF5",
    border: "#22C55E",
    text: "#14532D",
    soft: "#BBF7D0",
    strong: "#16A34A",
  },
  INACTIVE: {
    base: "#F3F4F6",
    border: "#D1D5DB",
    text: "#4B5563",
    soft: "#E5E7EB",
    strong: "#9CA3AF",
  },
};

export const resolveVariantStyle = (variant: IEnrStatusChipVariant) => {
  const tone = variant.startsWith("LIGHT_")
    ? "LIGHT"
    : variant.startsWith("DARK_")
      ? "DARK"
      : "DEFAULT";

  const baseKey = variant.replace(
    /^LIGHT_|^DARK_/,
    "",
  ) as IEnrStatusChipBaseVariant;
  const base = ENR_STATUS_CHIP_BASE_COLORS[baseKey];

  if (tone === "DARK") {
    return {
      chipBg: base.strong,
      chipBorder: base.strong,
      text: "#FFFFFF",
      highlightBg: base.border,
      highlightBorder: base.border,
      hoverBg: base.border,
      popoverBg: "#FFFFFF",
      popoverBorder: base.soft,
    };
  }

  if (tone === "LIGHT") {
    return {
      chipBg: base.base,
      chipBorder: base.border,
      text: base.text,
      highlightBg: base.soft,
      highlightBorder: base.strong,
      hoverBg: base.soft,
      popoverBg: "#FFFFFF",
      popoverBorder: base.soft,
    };
  }

  return {
    chipBg: base.base,
    chipBorder: base.border,
    text: base.text,
    highlightBg: base.soft,
    highlightBorder: base.strong,
    hoverBg: base.soft,
    popoverBg: "#FFFFFF",
    popoverBorder: base.soft,
  };
};
